/*
 * 列表搜索的 mixin
 */
import request from './server'
import Cookie from 'js-cookie'
/* eslint-disable */
export const listSearch = {
  data () {
    return {
      // 加载中
      loading: false,
    }
  },
  methods: {
    /*
     * 发送请求
     */
    sendReq (params, callback) {
      request({
        method: params.method || 'POST',
        url: params.url,
        data: params.data || {},
        withCredentials : true,
        params: params.payload || {},
        headers: {
          'Content-type': params.contentType || 'application/json;charset=utf-8',
          'token':Cookie.get('token'),
          ...params.headers
        }
      }).then((res) => {
        if (res && res.data) {
          callback && callback(res.data)
        }
      }, (error) => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/mixin/searchMixin.js